// extracted by mini-css-extract-plugin
export default {"select":"NzdHOSIY_fU6lVjZ16Op","mobile":"swZc02p0p8SzDO5sEOLX","buttonsHolder":"I3294TPkilW1Jzwr7oLw"};